export enum ActionTypes {
  SetLoading = 'ThimbleFlow/SetLoading',
  SetSelectedQuote = 'ThimbleFlow/SetSelectedQuote',
  SetPurchasedPolicyDetails = 'ThimbleFlow/SetPurchasedPolicyDetails',
  SetActivityID = 'ThimbleFlow/SetActivityID',
  SetPaymentOption = 'ThimbleFlow/SetPaymentOption',
  SetCart = 'ThimbleFlow/SetCart',
  SetUserAnswers = 'ThimbleFlow/UserAnswers',
}
